<div class="p-5">
    <ol class="timeline-container">
        <li *ngFor="let log of activityLogs; let last = last" class="timeline-entry">
        <div class="bg-card" *ngIf="!last" style="position:absolute; left:5px; top:5px; height: 100%; width:2px;"></div>
          <div class="timeline-marker bg-card">
            <mat-icon svgIcon="tabler_outline:plus" *ngIf="log.logType == 'CREATE'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:trash" *ngIf="log.logType == 'DELETE'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:mail-share" *ngIf="log.logType == 'SENT_BY_EMAIL'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:printer" *ngIf="log.logType == 'PRINT'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:download" *ngIf="log.logType == 'DOWNLOAD' || log.logType == 'DOWNLOAD_CLIENT'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:file-type-xml" *ngIf="log.logType == 'DOWNLOAD_XML'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:certificate" *ngIf="log.logType == 'DOWNLOAD_UPO'"></mat-icon>
            <mat-icon svgIcon="tabler_outline:pencil" *ngIf="log.logType == 'UPDATE'"></mat-icon>
            <mat-icon svgIcon="ksef:ksef-logo" *ngIf="log.logType == 'KSEF_SENT'"></mat-icon>
            <mat-icon svgIcon="ksef:ksef-logo" *ngIf="log.logType == 'KSEF_ERROR'" class="text-red-600"></mat-icon>
            <mat-icon svgIcon="tabler_outline:circle-check" *ngIf="log.logType == 'PAYMENT_RECEIVED'" class="text-green-600"></mat-icon>
            <mat-icon svgIcon="tabler_outline:circle-x" *ngIf="log.logType == 'PAYMENT_REVERTED'" class="text-orange-500"></mat-icon>
            <mat-icon svgIcon="tabler_outline:link" *ngIf="log.logType == 'ADVANCE_INVOICE_LINKED'" class="text-blue-600"></mat-icon>
            <mat-icon svgIcon="tabler_outline:link-off" *ngIf="log.logType == 'ADVANCE_INVOICE_UNLINKED'" class="text-orange-500"></mat-icon>
          </div>
          <div class="timeline-content">
            <div class="timeline-header">
              <div class="timeline-title flex items-center gap-2">
                <span *ngIf="log.logType == 'CREATE'">Utworzenie dokumentu</span>
                <span *ngIf="log.logType == 'CREATE' && log.data?.origin === 'external_api'" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300">
                  Przez API
                </span>
                <span *ngIf="log.logType == 'DELETE'">Usunięcie dokumentu</span>
                <span *ngIf="log.logType == 'PRINT'">Wydrukowanie dokumentu</span>
                <span *ngIf="log.logType == 'DOWNLOAD'">Pobranie dokumentu</span>
                <span *ngIf="log.logType == 'DOWNLOAD_CLIENT'">Pobrano przez klienta</span>
                <span *ngIf="log.logType == 'DOWNLOAD_XML'">Pobranie XML</span>
                <span *ngIf="log.logType == 'DOWNLOAD_UPO'">Pobranie UPO</span>
                <span *ngIf="log.logType == 'SENT_BY_EMAIL'">Wysłano na adres e-mail</span>
                <span *ngIf="log.logType == 'UPDATE'">Aktualizacja</span>
                <span *ngIf="log.logType == 'KSEF_SENT'">Wysłano do KSeF</span>
                <span *ngIf="log.logType == 'KSEF_SENT' && log.data?.origin === 'external_api'" class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-100 dark:bg-blue-900/40 text-blue-800 dark:text-blue-300">
                  Przez API
                </span>
                <span *ngIf="log.logType == 'KSEF_ERROR'">Błąd wysyłki do KSeF</span>
                <span *ngIf="log.logType == 'PAYMENT_RECEIVED'">Oznaczono jako uregulowaną</span>
                <span *ngIf="log.logType == 'PAYMENT_REVERTED'">Oznaczono jako do uregulowania</span>
                <span *ngIf="log.logType == 'ADVANCE_INVOICE_LINKED'">Powiązano fakturę zaliczkową</span>
                <span *ngIf="log.logType == 'ADVANCE_INVOICE_UNLINKED'">Odpięto fakturę zaliczkową</span>
                <!-- Info button for KSeF logs -->
                <button 
                  *ngIf="log.logType == 'KSEF_SENT' || log.logType == 'KSEF_ERROR'"
                  (click)="toggleDetails(log._id!)"
                  class="info-button"
                  [class.active]="isExpanded(log._id!)"
                  [matTooltip]="isExpanded(log._id!) ? 'Ukryj szczegóły' : 'Pokaż szczegóły'">
                  <mat-icon [svgIcon]="'tabler_outline:question-mark'" class="icon-size-3 bg-card rounded-full"></mat-icon>
                </button>
              </div>
                <div class="timeline-time">
                  <span>{{log.createdAt | date: 'dd MMMM YYYY'}}</span> <span class="ml-2">{{log.createdAt | date: 'HH:mm'}}</span>
                </div>
            </div>
            <div class="changes-container bg-card" *ngIf="log.logType == 'SENT_BY_EMAIL'">
                <div class="activity-log" *ngFor="let data of log.data">
                    <div class="change-field">
                        {{data.success ? 'Wysłano do:' : 'Nie udało się wysłać do:' }} {{data.receiver}}
                    </div>
                </div>
            </div>

            <div class="changes-container bg-card" *ngIf="log.logType == 'UPDATE'">
              <div class="activity-log" *ngFor="let change of log.data">
                <div class="change-field">
                  <span class="activity-display-name me-2">{{ change.displayName }}<span class="ms-2" *ngIf="change.extra">{{change.extra}}</span>:</span>
                  <span class="field-value" *ngIf="change.old != null">{{change.old}}</span>
                  <span class="mx-2 fw-bold" *ngIf="change.old != null && change.new != null && change.old != ''">na</span>
                  <span class="field-value" *ngIf="change.new != null">{{change.new == '' ? 'Brak' : change.new}}</span>
                </div>
              </div>
            </div>

            <!-- KSeF Success Log -->
            <div class="changes-container bg-card" *ngIf="log.logType == 'KSEF_SENT' && isExpanded(log._id!)">
              <div class="activity-log">
                <div class="change-field">
                  <span class="activity-display-name me-2">Numer KSeF:</span>
                  <span class="field-value font-mono text-sm">{{log.data.ksefNumber}}</span>
                </div>
                <div class="change-field" *ngIf="log.data.ksefInvoiceNumber">
                  <span class="activity-display-name me-2">Numer faktury:</span>
                  <span class="field-value">{{log.data.ksefInvoiceNumber}}</span>
                </div>
                <div class="change-field" *ngIf="log.data.ksefOrdinalNumber">
                  <span class="activity-display-name me-2">Numer porządkowy:</span>
                  <span class="field-value">{{log.data.ksefOrdinalNumber}}</span>
                </div>
                <div class="change-field" *ngIf="log.data.ksefInvoiceHash">
                  <span class="activity-display-name me-2">Hash faktury:</span>
                  <span class="field-value font-mono text-xs break-all">{{log.data.ksefInvoiceHash}}</span>
                </div>
                <div class="change-field" *ngIf="log.data.ksefStatus">
                  <span class="activity-display-name me-2">Status:</span>
                  <span class="field-value">{{log.data.ksefStatus}}</span>
                </div>
              </div>
            </div>

            <!-- KSeF Error Log -->
            <div class="changes-container bg-card border-l-4 border-red-500" *ngIf="log.logType == 'KSEF_ERROR' && isExpanded(log._id!)">
              <div class="activity-log">
                <div class="change-field">
                  <span class="activity-display-name me-2 text-red-600 font-semibold">Kod błędu:</span>
                  <span class="field-value font-mono">{{log.data.errorCode}}</span>
                </div>
                <div class="change-field">
                  <span class="activity-display-name me-2 text-red-600 font-semibold">Opis:</span>
                  <span class="field-value">{{log.data.errorDescription}}</span>
                </div>
                <div class="change-field" *ngIf="log.data.errorDetails && log.data.errorDetails.length > 0">
                  <span class="activity-display-name me-2 text-red-600 font-semibold">Szczegóły:</span>
                  <ul class="list-disc list-inside ml-4">
                    <li *ngFor="let detail of log.data.errorDetails" class="field-value text-sm">{{detail}}</li>
                  </ul>
                </div>
                <div class="change-field text-xs text-gray-500 dark:text-gray-400 mt-2">
                  <span>Data błędu: {{log.data.timestamp | date:'dd.MM.yyyy HH:mm:ss'}}</span>
                </div>
              </div>
            </div>

            <!-- Advance Invoice Linked Log -->
            <div class="changes-container bg-card border-l-4 border-blue-500" *ngIf="log.logType == 'ADVANCE_INVOICE_LINKED'">
              <div class="activity-log">
                <div class="change-field">
                  <span class="activity-display-name me-2">Numer faktury zaliczkowej:</span>
                  <span class="field-value font-semibold">{{log.data.advanceInvoiceNumber}}</span>
                </div>
                <div class="change-field">
                  <span class="activity-display-name me-2">Kwota zaliczki:</span>
                  <span class="field-value">{{log.data.advancePaymentAmount | number:'1.2-2'}} {{log.data.currency}}</span>
                </div>
              </div>
            </div>

            <!-- Advance Invoice Unlinked Log -->
            <div class="changes-container bg-card border-l-4 border-orange-500" *ngIf="log.logType == 'ADVANCE_INVOICE_UNLINKED'">
              <div class="activity-log">
                <div class="change-field">
                  <span class="activity-display-name me-2">Numer faktury zaliczkowej:</span>
                  <span class="field-value font-semibold">{{log.data.advanceInvoiceNumber}}</span>
                </div>
                <div class="change-field">
                  <span class="activity-display-name me-2">Powód:</span>
                  <span class="field-value">{{log.data.reason}}</span>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ol>
</div>
